import DonationPage, { getServerSideProps, donationUrl } from '@haaretz/s-pp-donation-page';
import Head from 'next/head';

const SHARE_MESSAGE =
  'I just helped fund access to independent journalism for students worldwide. Join me:';

function DonationPageWithMeta() {
  return (
    <>
      <Head>
        {/* We use this because facebook quote param is deprecated */}
        {/* https://developers.facebook.com/support/bugs/734680371318112/?comment_id=743056360480513 */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={donationUrl} />
        <meta property="og:title" content="Support Independent Journalism — Haaretz" />
        <meta property="og:description" content={`${SHARE_MESSAGE} ${donationUrl}`} />
      </Head>
      <DonationPage />
    </>
  );
}

export default DonationPageWithMeta;

export { getServerSideProps };
